import { combineReducers, Reducer } from 'redux';
import { reducer as cartReducer } from 'b2b-apps/shop/cart/redux/cart/reducer';
import { reducer as cartStatusReducer } from 'b2b-apps/shop/cart/redux/cartStatus/reducer';
import { CartActions, CartState } from 'b2b-apps/shop/cart/redux/types';
import { reducer as cartWishlistSearchReducer } from 'b2b-apps/shop/cart/redux/wishlistSearch/reducer';

const reducer: Reducer<CartState, CartActions> = combineReducers({
  cart: cartReducer,
  cartStatus: cartStatusReducer,
  wishlistSearch: cartWishlistSearchReducer,
});

export {
  reducer,
};
